import React, { memo, useCallback, useState } from "react";
import { Card, Input, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, Switch, message } from "antd";
import {
  useGetAdminUsersList,
  useGetAuthorityFindCategory,
  useGetAuthorityFindRoles,
  usePostAdminAddNewUser,
} from "core";

const NAMEANDFAMILY = "nameAndFamily";
const USERNAME = "userName";
const PASSWORD = "password";
const ROLE = "role";
const MOBILENUMBER = "mobileNumber";
const ISACTIVE = "isActive";
const CATEGORY = "category";
const administrator = "administrator";
const SUPERVISOR = "supervisor";
const HALLMANAGER= "hallManager";
const SALEMANAGER="saleManager";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const AddUser = memo(() => {
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const [status, setStatus] = useState(true);
  const {register,formState: { errors }}=useForm()
  
  const methods = useForm({
    defaultValues: {
      nameAndFamily: "",
      userName: "",
      password: "",
      role: [],
      mobileNumber: "",
      category: "",
      isActive: true,
      administrator: "",
      supervisor: "",
      saleManager:"",
      hallManager:""
    },
  });

  const { data: _data } = useGetAdminUsersList({
    pageNumber: "1",
    pageSize: "3000",
  });

  const { data: { data } = {}, isFetching } = useGetAuthorityFindRoles({
    pageSize: "3000",
    pageNumber: "1",
  });

  const { data:categoriesData  , isFetching:isFetchingCategory } = useGetAuthorityFindCategory({
    pageSize: "3000",
    pageNumber: "1",
  });

  const rolesItem = data?.roles?.map((item: { name: string }) => {
    return {
      value: item.name,
      label: item.name,
    };
  });

  const administratorItem = _data?.data?.users?.map((item: any) => {
    return {
      value: item.userName,
      label: item.nameAndFamily,
    };
  });

  const categoriesItem = categoriesData?.data?.categories?.map((item:any) => {
    return {
      value: item.id,
      label: item.name,
    };
  });




  const { handleSubmit, reset } = methods;

  const onSubmit = useCallback(
    ({
      nameAndFamily,
      userName,
      password,
      role,
      mobileNumber,
      category,
      isActive,
      administrator,
      supervisor,
      saleManager,
      hallManager
    }: {
      nameAndFamily: string;
      userName: string;
      password: string;
      mobileNumber: any;
      category: any;
      role: any;
      isActive: boolean;
      administrator: string;
      supervisor: string;
      saleManager:string;
      hallManager:string
    }) => {
      mutate({
        requestBody: {
          nameAndFamily: nameAndFamily.trim(),
          userName: userName.trim(),
          password: password.trim(),
          role: role,
          mobileNumber: mobileNumber.trim(),
          category:category.toString(),
          isActive: isActive,
          administrator: administrator,
          supervisor: supervisor,
          hallManager:hallManager,
          saleManager:saleManager
        },
      });
    },
    []
  );
  
  //////////////////////////////////////////////
  const { mutate, isPending} = usePostAdminAddNewUser({
    onSuccess: () => {
      reset();
      messageApi.open({
        type: "success",
        content: i18n.t("done"),
      });
    },
    onError: (error) => {
      messageApi.open({
        type: "error",
        content:i18n.t((error.message as any).message) ,
      });
    },
  });
  
  ////////////////////////////////////////////////////////////////
  return (
    <>
      {contextHolder}
      <Card title={i18n.t("addUser")}>
        <FormProvider {...methods}>
          <Form
            {...layout}
            name="nest-messages"
            onFinish={handleSubmit(onSubmit)}
          >
            <Form.Item>
              <Controller
                rules={{ required: i18n.t("isRequired") }}
                name={NAMEANDFAMILY}
              >
                <Input placeholder={i18n.t("nameAndFamily")} />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller
                rules={{ required: i18n.t("isRequired") }}
                name={USERNAME}
              >
                <Input placeholder={i18n.t("userName")} />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller
                rules={{ required: i18n.t("isRequired") }}
                name={PASSWORD}
              >
                <Input placeholder={i18n.t("password")} />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller name={ROLE}>
                <SelectBox
                  mode="tags"
                  aria-multiselectable
                  label={i18n.t("role")}
                  options={rolesItem}
                  placeholder={i18n.t("role")}
                />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller
                rules={{ required: i18n.t("isRequired") }}
                name={MOBILENUMBER}
              >
                <Input placeholder={i18n.t("mobileNumber")} />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller
                rules={{ required: i18n.t("isRequired") }}
                name={CATEGORY}
              >
               <SelectBox
                  allowClear
                  label={i18n.t("category")}
                  options={categoriesItem}
                  placeholder={i18n.t("category")}
                />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller  name={administrator}>
                <SelectBox
                  allowClear
                  label={i18n.t("administrator")}
                  options={administratorItem}
                  placeholder={i18n.t("administrator")}
                />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller name={SUPERVISOR}>
                <SelectBox
                  allowClear
                  label={i18n.t("supervisor")}
                  options={administratorItem}
                  placeholder={i18n.t("supervisor")}
                />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller name={HALLMANAGER}>
                <SelectBox
                  allowClear
                  label={i18n.t("hallManager")}
                  options={administratorItem}
                  placeholder={i18n.t("hallManager")}
                />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller name={SALEMANAGER}>
                <SelectBox
                 allowClear
                  label={i18n.t("saleManager")}
                  options={administratorItem}
                  placeholder={i18n.t("saleManager")}
                />
              </Controller>
            </Form.Item>

          
            <Form.Item label={status ? i18n.t("active") : i18n.t("deActive")}>
              <Controller name={ISACTIVE}>
                <Switch
                  checked={status}
                  onClick={() => {
                    setStatus(!status);
                  }}
                />
              </Controller>
            </Form.Item>

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                style={{ width: "100px" }}
                type="primary"
                isLoading={isPending}
                htmlType="submit"
              >
                {i18n.t("done")}
              </Button>
            </Form.Item>
          </Form>
        </FormProvider>
      </Card>
    </>
  );
});
export { AddUser };
